export const emitToast = (message, severity = 'info') => {
    const event = new CustomEvent('showToast', {
      detail: { message, severity },
    });
    window.dispatchEvent(event);
  };